import {
  PageViewInferface,
  SetEventInterface,
} from "./../../../interfaces/tagging.interface";
import {
  Component,
  inject,
  NgZone,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Router } from "@angular/router";
import { Accounts, AdditionalDatumInterface, RequestBody } from "@tae/interfaces";
import {
  MainService,
  StorageService,
  CryptoService,
  CreatePaymentOrderService,
} from "@tae/services";
import { ENV_CONFIG } from "@tae/tokens";
import { CODE_ERRORS } from "@tae/constants";
import { BottomSheetService } from "src/app/services/bottomSheet/bottom-sheet.service";
import { ErrorMessageInterface } from "src/app/interfaces/error-message.interface";
import {
  LabelsCardInterface,
  LabelsInsufficientInterface,
} from "src/app/interfaces/labels.interface";
import { CtrlRechargeService } from "src/app/services/ctrl-recharge/ctrl-recharge.service";
import { RechargeInterface } from "src/app/interfaces/ctrl-recharge.interface";
import {
  CardDialog,
  DialogBottomSheetOverview,
  DialogConsiderationComponent,
  InsufficientFundsDialog,
  RechargeSchedulesComponent
} from "@tae/components";
import { AccountsListComponent } from "src/app/components/accounts-list/accounts-list.component";
import { DialogErrorComponent } from "src/app/components/dialog-error/dialog-error.component";
import { TaggingService } from "src/app/services/tagging.service";
import { Subject, takeUntil, timer } from "rxjs";
import { TraceIdHelper } from "@tae/../src/assets/js/commons/trace-id.helper";
import { CurrencyPipe, DatePipe } from "@angular/common";

declare global {
  interface Window {
    Connect: {
      retrieveCards: any;
      retrieveContacts: any;
      obtainCollectData: any;
    };
  }
}
/*
  Devuelve el contacto seleccionado
 */
declare function retrieveContacts(): any;

/**
 * Metodo nativo para hacer solicitar validacion de token en autenticacio
 */
declare function requestToken(): any;

/**
 * Metodo nativo para hacer validacion de riesgo y posteriormente supertoken
 */
declare function evaluateRiskAssesment(transactionData): Promise<any>;

declare function vaildateNewCallbacks(): boolean;

/**
 * Metodo nativo para abrir el directorio
 */
declare function openDirectory(): any;

/**
 * Metodo para realizar llamado a funcion nativa
 *  con la que se finaliza la  aplicacion
 */
declare function quitApp(): any;
/**
 * Funcion para generar traceID
 */
declare function encode_deviceprint(): any;

@Component({
    selector: "app-captura",
    templateUrl: "./captura.component.html",
    styleUrls: ["./captura.component.scss"],
    standalone: false
})

/**
 * Clase controladora de formulario de ingreso de datos para recarga
 */
export class CapturaComponent implements OnInit, OnDestroy {
  //Datos del diccionario de commons
  public get textTokens(): any {
    return this.ctrlRecharge.textTokens;
  }

  /* Atributo para mostrar icono del directorio */
  public get showDirectory(): boolean {
    return this.ctrlRecharge.showDirectory;
  }

  /* Atributo para mostrar o no carousel de cuentas */
  public showSliderCuentas = false;

  /**Variable para bloquear boton en proceso */
  public inProcess: boolean = false;

  /* Almacena el valor con el cual una vez ingresando todos los campos se habilita o no el boton*/
  public get activeBtn(): boolean {
    const { amount, phone, biller, accountSelected } = this.recharge;
    return amount && phone && !!biller && !!accountSelected && this.inProcess;
  }

  /* Almacena el valor del numero celular que se obtiene del directorio*/
  public phoneOfContact: string;

  /*Almacena los valores que se le enviaran al servicio para realizar la recarga */
  requestBody: RequestBody = {
    buc: "",
    idBiller: "",
    montoPagar: undefined,
    numCuenta: "",
    numTarjeta: "",
    referencia: "",
    tipoTarjeta: "",
    token: "",
    idProducto: '',
  };

  public openDirectory = () => {
    try {
      retrieveContacts();
    } catch (error) {
      console.log("callback de agenda", error);
    }
  };

  public settingsErrorMessage: ErrorMessageInterface;

  public get labelsInsufficient(): LabelsInsufficientInterface {
    return {
      title: this.textTokens.INSUFFICIENT_FUNDS,
      bottomButton: this.textTokens.GOT_IT_BUTTON,
      closeButton: this.textTokens.CLOSE_DIALOG,
      dialogLabel: this.textTokens.INSUFFICIENT_FUNDS_LABEL,
    };
  }

  public get labelsCardDialog(): LabelsCardInterface {
    return {
      closeDialog: this.textTokens.CONFIRM_DIALOG_CANCEL,
      titleDialog: this.textTokens.CONFIRM_DIALOG_TITLE,
      title: this.textTokens.CONFIRM_DIALOG_SUB,
      buttonMessage: this.textTokens.CONFIRM_DIALOG_BUTTON_MESSAGE,
      buttonConfirm: this.textTokens.CONFIRM_DIALOG_BUTTON_OK,
    };
  }

  public get recharge(): RechargeInterface {
    return this.ctrlRecharge.recharge;
  }

  public get successBillers(): boolean {
    return !!this.ctrlRecharge?.billers?.length || false;
  }

  public get accounts(): Accounts[] {
    return this.ctrlRecharge.accounts;
  }

  public get errorAmount(): boolean {
    const { amount, accountSelected } = this.recharge;
    if (!amount || !accountSelected) return false;
    const { balance } = accountSelected.account;
    const { amount: balanceAmount } = balance.amount;
    return Number(balanceAmount) < amount;
  }

  /**
	 * Subject that unsubscribes from the Observables.
	 *
	 * @private
	 * @memberof CapturaComponent
	 */
	private _destroyed$ = new Subject<boolean>();

  private _isRechargeSchedule: boolean = false;

  private _isEditRecharge: boolean = false;

  private _dataBSS: any = {};

  public arrayDetailsRecharge: any[] = [
    { label: 'Primer recarga:', value: '', active: false , id: 'rechargeFirst', data: null },
    { label: 'Frecuencia:', value: 'MENSUAL', active: true, id: 'frecuency', data: 'MENSUAL' },
    { label: 'Monto:', value: '', active: true, id: 'amount', data: null },
    { label: 'Alias de recarga programada:', value: '', active: true, id: 'alias', data: null },
  ];

  private readonly mainService = inject(MainService);
  private readonly storageService = inject(StorageService);
  private readonly router = inject(Router);
  private readonly cryptoService = inject(CryptoService);
  private readonly createPaymentOrderService = inject(CreatePaymentOrderService);
  private readonly ngZone = inject(NgZone);
  private readonly bss = inject(BottomSheetService);
  private readonly taggingService = inject(TaggingService);
  private ctrlRecharge = inject(CtrlRechargeService);
  private readonly _environment = inject(ENV_CONFIG);
  private _currencyPipe = inject(CurrencyPipe);
  private _datePipe = inject(DatePipe);

  constructor() {
    window["angularComponentRef"] = {
      component: this,
      zone: this.ngZone,
      loadAngularFunction: (command, data) => {
        switch (command) {
          case "GET_PHONE":
            this.ctrlRecharge.phone = data ? data : "";
            break;
          case "error":
            console.warn("callbacks not found");
            this.ctrlRecharge.showDirectory = false;
            break;
        }
      },
      componentToken: (succesTkn, tipoOTP, date, errorTkn) =>
        this.receiveTokenFromNative(succesTkn, tipoOTP, date, errorTkn),
    };
  }
  /**
   *
   */
  ngOnInit(): void {
    const { accountSelected, biller, amount } = this.recharge;
    if (!accountSelected) {
      this.setAccount();
    }
    if (biller && !amount) {
      this.viewAmounts();
    }
    const pageView: PageViewInferface = {
      url: "recarga_celular/detalle",
      titulo: "recarga_celular|detalle",
      canalBanco: "supermovil",
      subsection1: "recarga_celular",
      versionApp: "",
      userId: "",
      entorno: this.storageService.get("ENV"),
      event: "PageView",
    };
    this.taggingService.setPageView(pageView);
  }

  private viewAmounts(_schedule?: boolean): void {
    let schedule = undefined
    if (_schedule) {
      const find = this.arrayDetailsRecharge.find(_item => _item.id === 'frecuency');
      schedule = {
        process: 'recarga_automatica',
        frecuency: (find.value as string).toLowerCase(),
      }
    }
    const data = {
        title: this.textTokens?.CAPTURA_AMOUNT_OPERATION,
        amounts: this.recharge.biller.additionalData,
        selected: (_evt: AdditionalDatumInterface) => this.onAmount(_evt, _schedule),
        config: {
          title: this.textTokens?.CAPTURA_AMOUNT_OPERATION,
          closeLabel: "Cerrar",
          backgroundColor: "secondary",
        },
        schedule,
      };
      this.bss.show(DialogBottomSheetOverview, data);
  }

  private componentInsufficient(): void {
    const data = {
      labels: this.labelsInsufficient,
      config: {
        closeLabel: this.labelsInsufficient.closeButton,
      },
    };
    this.bss.show(InsufficientFundsDialog, data);
  }

  private setAccount(): void {
    if (this.ctrlRecharge.accounts.length === 1) {
      const account = this.ctrlRecharge.accounts[0];
      this.ctrlRecharge.accountSelected = account;
      let { amount } = account.account?.balance;
      if (parseInt(amount.amount) <= 0) {
        this.componentInsufficient();
      }
    } else {
      const dataBSS = {
        title: this.textTokens?.SELECT_ORIGIN_ACCOUNT,
        accounts: this.accounts,
        selected: (_evt: Accounts) => this.onAccountSelected(_evt),
        config: {
          title: this.textTokens?.SELECT_ORIGIN_ACCOUNT,
          closeLabel: "Cancelar",
        },
      };
      this.bss.show(AccountsListComponent, dataBSS);
    }
  }

  public onAccountSelected(_evt: Accounts): void {
    this.ctrlRecharge.accountSelected = _evt;
    this.bss.hide();
    const { amount } = _evt?.account?.balance;
    if (parseInt(amount.amount) <= 0) {
      this.componentInsufficient();
    }
  }
  /**
   * Escucha el elemento seleccionado en el SelectAccount
   *
   * @param account
   */
  getAccountSelected(account: Accounts) {
    if (account) {
      const { amount } = account.account.balance;
      if (parseInt(amount.amount) <= 0) {
        this.componentInsufficient();
      }
      this.ctrlRecharge.accountSelected = account;
    }
  }

  onCompanies(): void {
    const action: SetEventInterface = {
      event: "payments",
      categoria: "recarga_celular",
      accion: "detalle",
      etiqueta: "selecciona_la_compania",
      canalBanco: "supermovil",
      url: "recarga_celular/detalle",
      userID: "",
    };
    this.taggingService.setEvent(action);
    this.router.navigateByUrl("/companies");
  }

  /**
   * Escucha el input del numero de telefono
   * @param phone
   */
  getPhone(phone: string | undefined) {
    this.ctrlRecharge.phone = phone;
  }

  public selectAmount = (): void => {
    if (!this.recharge.biller) {
      return;
    }

    const action: SetEventInterface = {
      event: "payments",
      categoria: "recarga_celular",
      accion: "detalle",
      etiqueta: "selecciona_monto",
      canalBanco: "supermovil",
      url: "recarga_celular/detalle",
      userID: "",
    };
    this.taggingService.setEvent(action);
    this.viewAmounts()
  };

  public onAmount(_evt: AdditionalDatumInterface, _schedule?: boolean) {
    this.inProcess = true;
    if (!_evt) {
      return;
    }
    if (!_schedule) {
      this.ctrlRecharge.amount = Number(_evt.monto);
    }
    this.ctrlRecharge.product = _evt.idProducto;
    if(_schedule) {
      this._setDataRechargeShedule(
        `${this._currencyPipe.transform(Number(_evt.monto), 'MXN', 'symbol', '1.2-2')} MXN`,
        "amount",
        Number(_evt.monto)
      );
      this.editPaymentSchesule();
    }
  }

  /**
   * Funcion que setea el valor de los detalles de la recarga programada
   * @param value
   * @param id
   * @param data
   */
  private _setDataRechargeShedule(value: string, id: string, data: any, active: boolean = true): void {
    if (value) {
      this.arrayDetailsRecharge = this.arrayDetailsRecharge.map(item => {
        if (item.id === id) {
          return { ...item,
                value: value,
                data: data,
                active: active
              };
        }
        return item;
      });
    }
  }

  /**
   * Si se esta en un ambiente local manda a llamar directo al servicio si no va por la validacion de token
   * a aplicacion nativa
   */
  continue(): void {
    if (!this.activeBtn) {
      return;
    }

    const action: SetEventInterface = {
      event: "payments",
      categoria: "recarga_celular",
      accion: "detalle",
      etiqueta: "continuar",
      canalBanco: "supermovil",
      url: "recarga_celular/detalle",
      userID: "",
    };
    const $confirmDialog = new Subject<string>();
    this.taggingService.setEvent(action);
    this._dataBSS = {
      labels: this.labelsCardDialog,
      biller: this.recharge.biller,
      card: this.recharge.accountSelected,
      amount: this.recharge.amount,
      cel: this.recharge.phone,
      confirmRechargeSchedule: false,
      isRechargeSchedule: this._isRechargeSchedule,
      arrayDetailsRecharges: this._isRechargeSchedule ? this.arrayDetailsRecharge: [],
      config: {
        title: this.labelsCardDialog.titleDialog,
        closeLabel: this.labelsCardDialog.closeDialog,
      }
    };

    this.bss.show(CardDialog, {
      ...this._dataBSS,
      $confirmDialog: $confirmDialog
    });

    $confirmDialog.pipe(takeUntil(this._destroyed$)).subscribe({
      next: () => {
        this.sendRequest();
        $confirmDialog.unsubscribe();
      },
    });
  }


  public sendRequest(): void {
    this.storageService.set("data", this.storageService.safeStringify(this.ctrlRecharge.recharge));
    console.log(this._dataBSS, 'sendRequest');
    console.log("Se inicia send request")
    try {
      console.log("Comienza validación del lado de front")
      if(vaildateNewCallbacks()){
        const THIS = this;
        evaluateRiskAssesment(this.ctrlRecharge).then((resp) => {
        THIS.storageService.set("token2fa", resp.token);
        THIS.sendService();
      })
      } else {
        requestToken();
      }
    } catch (error) {
      console.log(error, "callback requestToken");
    }
    // this.sendService();
  }

  /**
   * Obtiene la llave de cifrado del storage y cifra la info a enviar al servicio
   * dependiendo la respuesta del servicio pasa al ultimo paso o manda mensaje de error
   */
    async sendService() {
    const data = JSON.parse(this.storageService.get("data"));
    const objGeo = this.storageService.get("objGeo");
    const token2fa = this.storageService.get('token2fa');
    // console.log(token2fa, 'sendService / token2fa', null);
    this.mainService.showSpinner(true);
    if (!token2fa) {
      return;
    }
    if (objGeo !== null && objGeo) {
      let objeto = await this.createBody();
      this.createPaymentOrderService.recargarTAE(objeto).subscribe(
        (response) => {
          const { statusCode, statusDesc } = response.status;
          this.mainService.showSpinner(false);
          if (
            statusCode === "SCF000" ||
            (statusCode === "FORW00" && statusDesc === CODE_ERRORS["FORW00"].message && response?.data)
          ) {
            const date = new Date();
            // Agregar la recarga al historial en memoria para que se vea sin llamar a /SSO/validate
            this.ctrlRecharge.addRechargeToHistory({
              phoneNumber: this.recharge.phone,
              carrierId: this.recharge.biller?.billerId,
              amount: null,
              processingDate: date.toISOString(),
              idProducto: this.recharge.product
            });
            const buildData = {
              folio: response["data"]?.folio,
              do: date,
              ho: date.toLocaleTimeString("es-MX"),
              statusCode: response["status"].statusCode,
              ...data,
              confirmRechargeSchedule: false,
              amount: this.recharge.amount,
              isRechargeSchedule: this._isRechargeSchedule,
              dataBSS: this._isRechargeSchedule ? JSON.stringify(this._dataBSS) : null,
            }
            this.storageService.set("data", this.storageService.safeStringify(buildData));
            this.router.navigate(["ticket"]);
          } else if (statusCode == "COFAT3") {
            //mapear error de token
            const message =
              this.textTokens.ERROR_MESSAGE_DEFAULT +
              "-" +
              response["status"].statusCode;
            // const codeError = `GOTA06 ${response["status"].statusCode}`;
            const { status, title, icon } = CODE_ERRORS["STATUS_RESPONSE_PAY"];
            this.errorMessage({
              message,
              code: response["status"].statusCode,
              status,
              title,
              icon: icon,
            });
          }
          else if (statusCode === '-14' || statusCode === '-12') {
            const { status, title, image, icon, message } = CODE_ERRORS["STATUS_RESPONSE_NUMBER"];
            this.errorMessage({
              message,
              code: statusCode,
              status,
              title,
              pathImage: image,
              icon: icon,
              buttonLabel: 'Reitentar'
            });
          } else {
            // const codeError = `GOTA05 ${response["status"].statusCode}`;
            const { status, title, image, icon } =
              CODE_ERRORS["STATUS_RESPONSE_PAY"];
            this.errorMessage({
              message: response["status"].statusDesc,
              code: response["status"].statusCode,
              status,
              title,
              pathImage: image,
              icon: icon,
            });
          }
        },
        (err: any) => {
          this.mainService.showSpinner(false);
          const { message, code, status, title, image, icon } =
            CODE_ERRORS["STATUS_RESPONSE_PAY"];
          this.errorMessage({
            message,
            code,
            status,
            title,
            pathImage: image,
            icon: icon,
          });

          /**
           // Pruebas en DEV
            const date = new Date();
            const buildData = {
              folio: '12345',
              do: date,
              ho: date.toLocaleTimeString("es-MX"),
              statusCode: "2000",
              ...data,
              confirmRechargeSchedule: false,
              isRechargeSchedule: this._isRechargeSchedule,
              dataBSS: this._isRechargeSchedule ? JSON.stringify(this._dataBSS) : null,
            }
            this.storageService.set("data", this.storageService.safeStringify(buildData));
            this.router.navigate(["ticket"]);
          */
        }
      );
    } else {
      const { message, code, status, title, image, icon } =
        CODE_ERRORS["STATUS_RESPONSE_GEO"];
      this.errorMessage({
        message,
        code,
        status,
        title,
        pathImage: image,
        buttonLabel: this.textTokens.ACTIVATE,
        icon: icon,
      });
    }
  }

  /**
   * Set and save traceId for transmit
   */
  private _setCodes() {
    const device =
      typeof encode_deviceprint() === "function"
        ? encode_deviceprint()
        : (window as any).encode_deviceprint();
    const traceId = new TraceIdHelper().generateTraceID(device);
    this.storageService.set("traceId", traceId);
  }

    private async createBody(): Promise<any> {
    const ke = this.storageService.get("ke");
    const key = ke.substr(-16);
    const iv = ke.substr(0, 16);
    this.inProcess = false
    this._setCodes();
    const isTransmit = localStorage.getItem("isTransmit");
    const token = isTransmit.toString() === 'true'
      ? "11111111"
      : this.storageService.get("token2fa");
    this.requestBody.token = token?.substring(0, 8);
    const { biller, amount, accountSelected, phone, product } = this.recharge;
    this.requestBody.buc = this.storageService.get("buc");
    this.requestBody.idBiller = biller.billerId;
    this.requestBody.montoPagar = Number(amount).toFixed(2);
    this.requestBody.numCuenta =
      accountSelected?.account?.accountNumber?.toString() || "";
    this.requestBody.numTarjeta = accountSelected.card.cardNumber.toString();
    this.requestBody.referencia = phone.toString();
    this.requestBody.tipoTarjeta = accountSelected.card.cardType.toString();
    this.requestBody.idProducto = product || '';
    console.log(this.requestBody, 'createBody / requestBody');
    return {
      geolocalizacionTaePrimaryRequestTO: JSON.parse(
        this.storageService.get("objGeo")
      ),
      requestBodyCrypt: await this.cryptoService.Encriptar(
        JSON.stringify(this.requestBody),
        key,
        iv
      ),
    };
  }

  /**
   * FUNCION QUE RECIBE EL TOKEN DESDE LA NATIVA
   * @param token
   * @param tipoOTP
   * @param date
   * @param message
   */
  receiveTokenFromNative(
    token: string,
    tipoOTP: string,
    date: string,
    message: string
  ) {
    this.mainService.showSpinner(true);
    const THIS = this;
    this.ngZone.run(() => {
      if (token && token !== null && token !== undefined) {
        THIS.storageService.set("token2fa", token);
        THIS.storageService.set("isTransmit", tipoOTP);
        THIS.sendService();
      } else {
        THIS.mainService.showSpinner(false);
      }
    });
  }

  /**
   *
   * @param { ErrorMessageInterface }_settings
   */
  errorMessage(_settings: ErrorMessageInterface): void {
    this.inProcess = true;
    this.mainService.showSpinner(false);
    this.settingsErrorMessage = {
      ..._settings,
      pathImage: _settings.pathImage || "ta-disconnected",
      icon: _settings.icon || "plug",
      buttonLabel:
        _settings.buttonLabel || this.textTokens.ERROR_MESSAGE_ACCEPT,
      closeLabel: _settings.closeLabel || this.textTokens.ERROR_MESSAGE_CLOSE,
    };
    const dataBSS = {
      _data: this.settingsErrorMessage,
      close: () => this.onCloseError(),
      config: {
        closeLabel: this.settingsErrorMessage.closeLabel,
      },
    };
    timer(900).subscribe(() => {
      this.bss.show(DialogErrorComponent, dataBSS);
    });
  }

  public onCloseError(): void {
    const { status } = this.settingsErrorMessage;
    this.bss.hide();
    if (
      status &&
      (status === "STATUS_RESPONSE_CAT" ||
        status === "STATUS_RESPONSE_KE" ||
        status === "STATUS_RESPONSE_SSO" ||
        status === "STATUS_RESPONSE_CTAS" ||
        status === "STATUS_RESPONSE_GEO" ||
        status === "STATUS_RESPONSE_TYC" ||
        status === "STATUS_NO_ACC")
    ) {

      try {
        quitApp()
      } catch (error) {
        console.log(error, 'exit app captura');

      }
    }
  }

  public showConsiderations(_evt: boolean): void {
    if (!_evt) {
      return;
    }
    const dataBSS = {
      considerations: this.textTokens?.CONSIDERATIONS_DIALOG,
      title: "Toma en cuenta que",
      closeIcon: "ta-close_gray",
      close: () => this.closeDialog(),
      config: {
        title: "Toma en cuenta que",
        closeLabel: "Cerrar",
      },
    };
    this.bss.show(DialogConsiderationComponent, dataBSS);
  }

  closeDialog() {
    this.bss.hide();
  }

  public onBack(): void {
    this.router.navigateByUrl("/history");
  }

  // Último día del mes
  private _getLastDayOfNextMonth(date: Date) {
    const newDate = new Date(date)
    return newDate.setMonth(newDate.getMonth() + 1);
  }

  private _setInitDetailsRecharge() {
    if (!this._isEditRecharge) {
      const alias = this.recharge.biller?.name;
      const amount = this.recharge.amount;
      const date =  this._getLastDayOfNextMonth(new Date());
      const day = this._datePipe.transform(date, 'dd') ?? '';
      const month = this._datePipe.transform(date, 'LLLL') ?? '';
      const year = this._datePipe.transform(date, 'YYYY') ?? '';
      const dateFormatSelected = `${day} de ${month} ${year}`;
      const amountBuild = this._currencyPipe.transform(amount, 'MXN', 'symbol', '1.2-2');
      this._setDataRechargeShedule(amountBuild ? `${amountBuild} MXN` : '', "amount", amount);
      this._setDataRechargeShedule(alias, "alias", alias );
      this._setDataRechargeShedule(dateFormatSelected, 'rechargeFirst', date, false);
    }
  }

  public activeStatusSchedule(status: boolean) {
    this._isRechargeSchedule = status;
    if (status) {
      this._setInitDetailsRecharge();
    }
  }

  public editPaymentSchesule(): void {
    const $getDataEditRecharges = new Subject<string>();
    const data = {
      title: 'Recarga programada',
      config: {
        title: 'Recarga programada',
        closeLabel: "Cerrar",
        backgroundColor: "secondary",
      },
      arrayDetailsRecharge: this.arrayDetailsRecharge,
      $getDataEditRecharges: $getDataEditRecharges,
    };
    this.bss.show(RechargeSchedulesComponent, data);

    $getDataEditRecharges.pipe(takeUntil(this._destroyed$))
    .subscribe({
      next: (data: any) => {
        let response = data;
        if (!Array.isArray(response)) {
          response = data.arrayDetailsRecharge
        }
        this._isEditRecharge = true;
        this.arrayDetailsRecharge = response;
        const alias = this.arrayDetailsRecharge.find(item => item.id === 'alias')?.value;
        if (!alias) {
          this._setDataRechargeShedule(this.recharge.biller.name, "alias", this.recharge.biller.name);
        }
        $getDataEditRecharges.unsubscribe();
        this.bss.hide();
        if (data?.amount) {
          this.viewAmounts(true);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next(true);
		this._destroyed$.complete();
  }
}
